import StripeDonationForm from './StripeDonationForm'
import StripeOneTimeDonationForm from './StripeOneTimeDonationForm'

export default function DonationCTA() {
  // const donateButtonProps = useFollowCursor()
  // const sponsorButtonProps = useFollowCursor() // No longer needed

  return (
    <div className="w-screen flex justify-center pt-32 pb-16 mb-8">
      <div className="w-full max-w-[1280px] px-8">
        {/* Header section */}
        <div className="text-center max-w-[580px] mx-auto">
          <p className="body-medium text-black/50 mb-4">¡Súmate a ser parte!</p>
          <h2 className="headline-large">Participa en La Gaviota por medio de una donación</h2>
        </div>

        {/* Cards section */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-16">
          {/* One-Time Donation Card (Stripe) */}
          <StripeOneTimeDonationForm />

          {/* Stripe Donation Card (Monthly) */}
          <StripeDonationForm gradient="orange" />
        </div>
      </div>
    </div>
  )
} 